import { useState } from 'react'
import { criptografarDado } from '../../helpers'
import menuOpcoes from '../../interfaces/propsMenuOpcoes'
import SubMenuOpcoes from '../SubMenuOpcoes'
import '../../styles/menuopcoes.css'
import Permissoes from '../../middleware/Permissoes'

function MenuCadastros (props: menuOpcoes) {

    const [subMenu, setSubMenu] = useState(false)

    function exibirSubmenu () {
        setSubMenu (subMenu => !subMenu)
    }

    return (
        <Permissoes permissoes={['master', 'administrativo', 'atendimento', 'cadastro_acesso']}>
            <div>
                <div id = 'menuOpcoes' onClick={exibirSubmenu}>
                    {<img id = 'iconeMenu' src= {props.icone} alt = {props.alt}></img>}
                    <p id = 'tituloMenu'>{props.titulo}</p>
                </div>
                <div id = 'submenuOpcoes'>
                    <Permissoes permissoes={['master', 'administrativo', 'atendimento', 'cadastro_cliente']}>
                        {subMenu && <SubMenuOpcoes redirect = {`/cadastros/${criptografarDado('cliente')}`} texto = 'Clientes' />}
                    </Permissoes>
                    <Permissoes permissoes={['master', 'administrativo', 'atendimento', 'cadastro_responsavel']}>
                        {subMenu && <SubMenuOpcoes redirect = {`/cadastros/${criptografarDado('responsavel')}`} texto = 'Responsáveis' />}
                    </Permissoes>
                    <Permissoes permissoes={['master', 'administrativo', 'cadastro_colaborador']}>
                        {subMenu && <SubMenuOpcoes redirect = {`/cadastros/${criptografarDado('colaborador')}`} texto = 'Colaboradores' />}
                    </Permissoes>
                    <Permissoes permissoes={['master', 'administrativo', 'cadastro_fornecedor']}>
                        {subMenu && <SubMenuOpcoes redirect = {`/cadastros/${criptografarDado('fornecedor')}`} texto = 'Fornecedores' />}
                    </Permissoes>
                </div>
            </div>
        </Permissoes>
    )
}

export default MenuCadastros